import { signIn as signInClient } from '../clients/SignIn';
import {
  InvalidCredentialsError,
  SignInApiError,
  SignInRateLimitedError,
  TurnstileVerificationError,
} from '../errors';
import type { ISignInRequest } from '../types/ISignInRequest';
import type { ISignInResponse } from '../types/ISignInResponse';

const signIn = async (payload: ISignInRequest): Promise<ISignInResponse> => {
  try {
    return await signInClient(payload);
  } catch (error) {
    // Specific conditions first, then a catch-all that surfaces whatever
    // message the BE wrote (instead of "Request failed with status code …").
    const typedError =
      InvalidCredentialsError.fromAxiosError(error) ??
      SignInRateLimitedError.fromAxiosError(error) ??
      TurnstileVerificationError.fromAxiosError(error) ??
      SignInApiError.fromAxiosError(error);

    throw typedError ?? error;
  }
};

export const AuthService = {
  signIn,
};
